module.exports = __webpack_public_path__ + "89d2454691badf16e45a92a46ff8be55.svg";